<template>
  <div>
    <!-- Filter Section-->
    <div class="filter-section">
      <b-row class="mb-3">
        <b-col
          cols="12"
          lg="3"
          md="6"
        >
          <v-text-field
            id="searchInput"
            v-model="ContractNumberName"
            append-icon="fas fa-search"
            class="search-input"
            dense
            label="Vertrag suchen..."
            outlined
          />
        </b-col>

        <b-col
          cols="12"
          lg="3"
          md="6"
        >
          <v-select
            v-model="RoleName"
            :items="rolesOptions"
            clearable
            dense
            item-text="name"
            item-value="name"
            label="Rolle filtern"
            outlined
          />
        </b-col>

        <b-col
          cols="12"
          lg="3"
          md="6"
        >
          <v-text-field
            v-model="ResponsibleName"
            append-icon="fas fa-search"
            class="search-input"
            dense
            label="Zuständigen suchen..."
            outlined
          />
        </b-col>

        <b-col
          class="d-flex align-items-center justify-content-between"
          cols="12"
          lg="3"
          md="6"
        >
          <label class="ml-2 mt-4 mr-0">
            Nur Verträge mit inaktiven Zuständigen anzeigen
          </label>
          <v-switch
            v-model="OnlyContractWithInactiveResponsible"
            color="#e72b37"
            inset
          />
        </b-col>
      </b-row>
    </div>
    <div>
      <!-- Table Section -->
      <div
        class="mt-5 ml-3"
        style="width: 100%"
      >
        <b-select
          v-model="resultsPerPage"
          class="custom-select ml-1"
          style="width: 62px; height: 31px; font-size: 12px"
        >
          <option :value="10">
            10
          </option>
          <option :value="25">
            25
          </option>
          <option :value="50">
            50
          </option>
          <option :value="100">
            100
          </option>
        </b-select>
        <label
          style="font-weight: bold; margin-left: 3px"
        >Anzahl Resultate</label>
        <b-pagination
          v-model="currentPage"
          :per-page="resultsPerPage"
          :total-rows="totalNumberOfContracts"
          class="float-right mr-3"
          first-text="<<"
          last-text=">>"
          next-text="Nächste"
          prev-text="Vorherige"
        />
        <div v-if="totalNumberOfContracts > 0">
          {{ (currentPage - 1) * resultsPerPage + 1 }} bis
          {{ resultsPerPage * currentPage }} von
          {{ totalNumberOfContracts }} Resultaten
        </div>
        <div v-else>
          keine Resultate
        </div>
      </div>
      <v-flex
        v-if="isLoading"
        justify-center
      >
        <u-loader />
      </v-flex>
      <table
        v-else
        class="w-100 ml-2 mt-5 styled-table"
      >
        <thead>
          <tr>
            <th>Gav-Nummer</th>
            <th>Vertragsname</th>
            <th
              v-for="role in roles"
              :key="role.id"
            >
              {{ role }}
            </th>
            <!-- dynamic roles -->
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="contract in contractsAndResponsibilities"
            :key="contract.id"
          >
            <td>
              <a
                :href="`/contract-overview/${contract.contractNumber}/${
                  contract.versionNumber
                }`"
                class="custom-link"
                target="_blank"
              >
                {{ contract.contractNumber }}
              </a>
            </td>
            <td>
              <a
                :href="`/contract-overview/${contract.contractNumber}/${
                  contract.versionNumber
                }`"
                class="custom-link"
                target="_blank"
              >
                {{ contract.contractName }}
              </a>
            </td>
            <td
              v-for="role in roles"
              :key="role"
            >
              <ul style="padding-left: 20px; list-style-type: disc">
                <li
                  v-for="responsibleRole in contract.responsibleRoles.filter(
                    (r) => r.roleName === role,
                  )"
                  :key="responsibleRole.contactId"
                >
                  <a
                    v-if="responsibleRole.contactId"
                    :href="`/contacts/edit?contact=${responsibleRole.contactId}`"
                    :style="{
                      color: responsibleRole.inactive ? '#e72b37' : 'black',
                    }"
                    class="custom-hover"
                    target="_blank"
                  >
                    {{ responsibleRole.responsibleName }}
                  </a>
                  <a
                    v-else-if="responsibleRole.organisationId"
                    :href="`/organisation/edit?organisationNr=${
                      responsibleRole.organisationId
                    }`"
                    :style="{
                      color: responsibleRole.inactive ? '#e72b37' : 'black',
                    }"
                    class="custom-hover"
                    target="_blank"
                  >
                    {{ responsibleRole.responsibleName }}
                  </a>
                  <span v-else>
                    {{ responsibleRole.responsibleName }}
                  </span>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { GetContractsAndResponsibilities } from "@/services/user.crm.service";

export default {
  name: "Overview",

  data() {
    return {
      isLoading: false,
      errorObject: null,
      totalNumberOfContracts: 0,
      currentPage: 1,
      resultsPerPage: 25,
      sortOrder: 0,
      sortedProperty: "",
      contractsAndResponsibilities: [],
      ResponsibleName: "",
      RoleName: "",
      OnlyContractWithInactiveResponsible: false,
      ContractNumberName: "",
      roles: [],
      rolesOptions: [],
    };
  },
  watch: {
    currentPage() {
      this.getContractsAndResponsibilities();
    },
    resultsPerPage() {
      if (this.currentPage === 1) {
        this.getContractsAndResponsibilities();
      } else {
        this.currentPage = 1;
      }
    },
    OnlyContractWithInactiveResponsible() {
      if (this.currentPage === 1) {
        this.getContractsAndResponsibilities();
      } else {
        this.currentPage = 1;
      }
    },
    ResponsibleName() {
      if (this.currentPage === 1) {
        this.getContractsAndResponsibilities();
      } else {
        this.currentPage = 1;
      }
    },
    RoleName() {
      if (this.currentPage === 1) {
        this.getContractsAndResponsibilities();
      } else {
        this.currentPage = 1;
      }
    },
    ContractNumberName() {
      if (this.currentPage === 1) {
        this.getContractsAndResponsibilities();
      } else {
        this.currentPage = 1;
      }
    },
  },

  created() {
    this.getContractsAndResponsibilities();
  },

  methods: {
    getContractsAndResponsibilities() {
      this.isLoading = true;
      this.contractsAndResponsibilities = [];
      GetContractsAndResponsibilities(
        this.ContractNumberName,
        this.OnlyContractWithInactiveResponsible,
        this.RoleName ? this.RoleName : "",
        this.ResponsibleName,
        this.sortedProperty,
        this.sortOrder,
        this.currentPage,
        this.resultsPerPage,
        (response) => {
          if (response.contractOfResponsibleRoles) {
            this.contractsAndResponsibilities =
              response.contractOfResponsibleRoles;
          }

          if (response.roleColumns) {
            this.roles = response.roleColumns;
          }

          if (!this.rolesOptions.length && response.roleFilters) {
            this.rolesOptions = response.roleFilters;

            this.rolesOptions.unshift("");
          }

          this.totalNumberOfContracts = response.numberOfItems;
          this.isLoading = false;
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
  },
};
</script>

<style scoped>
.styled-table {
  border-collapse: collapse;
  width: 100%;
  margin: 25px 0;
  font-size: 1em;
  font-family: "Arial", sans-serif;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  text-align: left;
}

.styled-table thead tr {
  background-color: #e72b37;
  color: #ffffff;
  text-align: left;
  font-weight: bold;
}

.styled-table tbody tr {
  border-bottom: 1px solid #000000;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 3px solid #e72b37;
}

.styled-table tbody tr:hover {
  background-color: #f3f3f3;
}

.styled-table td ul {
  padding-left: 20px;
  list-style-type: disc;
  margin: 0;
}

.styled-table td ul li {
  margin-bottom: 5px;
}

/deep/ .page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #e72b37;
  border-color: red;
}

/deep/ .page-link:hover {
  z-index: 2;
  color: red;
  text-decoration: none;
  background-color: #fdd;
  border-color: #fdd;
}

/deep/ a:hover {
  color: #0056b3;
  text-decoration: underline;
}

/deep/ .page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: red;
  background-color: rgb(255, 255, 255);
  border: 1px solid #dee2e6;
}

.custom-select.filled-input {
  border-bottom-color: red;
  background-color: #ededed;
  font-weight: bold;
  color: #333;
}

.custom-select {
  position: relative;
  display: inline-block;
  width: 100%;
  height: 40px;
  line-height: 40px;
  color: #aaa;
  background-color: #fff;
  border: none;
  border-bottom: 2px solid rgba(0, 0, 0, 0.1);
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
  padding: 0 10px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus {
  outline: none;
  border-bottom: 2px solid #333;
  color: #333;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

/* CSS für den Pfeil */

.custom-select:after {
  content: "";

  position: absolute;

  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  margin-top: -4px;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #333;
  transition: all 0.3s ease-in-out;
}

.custom-select:focus:after {
  margin-top: -2px;
  border-top: 5px solid #fdd;
  transform: rotate(180deg);
}

.custom-link {
  color: #000000 !important;
  text-decoration: none;
  position: relative;
  transition:
    color 0.3s ease,
    text-shadow 0.3s ease,
    transform 0.3s ease;
}

.custom-link:hover {
  color: #b83d3d !important;
  text-decoration: underline;
  transform: scale(1.05);
}

.custom-hover {
  transition:
    color 0.3s ease,
    text-shadow 0.3s ease,
    transform 0.3s ease;
}

.custom-hover:hover {
  color: #b83d3d !important;
  text-decoration: underline;
  transform: scale(1.05);
}
</style>
